import React from 'react';
import CSSTransition from 'react-transition-group/CSSTransition';
import Button from 'Shared/Button';
import { translate } from 'Shared/translate';
import { scrollPosition, on } from 'SiteLayout/Root';
import * as styles from './base.scss';
export default class NetworkError extends React.Component {
    constructor(props) {
        super(props);
        this.onRetry = () => {
            if (!isOnline()) {
                // If you click Retry we don't want to show the "You're offline" message again
                this.retriedWhileOffline = true;
            }
            this.props.reload();
        };
        this.state = {
            visible: this.isVisible(props),
            dismissed: null,
        };
        this.hideTimer = null;
    }
    isVisible(props) {
        if (props.loadFailure === null) {
            return false;
        }
        else {
            return (this.state &&
                this.state.dismissed !== props.loadFailure &&
                // AccountButton handles failed requests that requires auth
                props.loadFailure.status !== 401 &&
                // Don't bother the user if we're showing a full version of the page
                (!props.loadFailure.isShowingFullCachedPage || props.loadFailure.status <= 500));
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.loadFailure !== this.props.loadFailure || nextState.visible !== this.state.visible;
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const visible = this.isVisible(nextProps);
        if (visible !== this.state.visible) {
            if (!this.retriedWhileOffline &&
                visible &&
                !isOnline() &&
                this.ignoredOfflineWarning &&
                !oneHourHasPassedFrom(this.ignoredOfflineWarning)) {
                // Don't hassle the user by telling them about offline all the time
                return;
            }
            this.setState({
                visible: visible,
                dismissed: null,
            });
            this.clearHideTimer();
            if (visible) {
                this.hideTimer = setTimeout(() => {
                    this.onDismiss();
                }, 4000);
                this.scrollPositionWhenErrorShown = scrollPosition();
                this.scrollListener = on('scroll', () => {
                    const newPosition = scrollPosition();
                    if (newPosition - this.scrollPositionWhenErrorShown > 75) {
                        this.onDismiss();
                    }
                });
            }
        }
    }
    clearHideTimer() {
        if (this.hideTimer) {
            clearTimeout(this.hideTimer);
            this.hideTimer = null;
        }
    }
    onDismiss() {
        if (this.scrollListener) {
            this.scrollListener();
            this.scrollListener = null;
        }
        this.clearHideTimer();
        if (!isOnline()) {
            this.ignoredOfflineWarning = new Date();
            this.retriedWhileOffline = false;
        }
        this.setState({ visible: false, dismissed: this.props.loadFailure });
    }
    render() {
        const showOfflineMessage = !isOnline() && !this.retriedWhileOffline;
        return (React.createElement(CSSTransition, { in: this.state.visible, classNames: {
                appear: styles.enter,
                appearActive: styles.enterActive,
                enter: styles.enter,
                enterActive: styles.enterActive,
                exit: styles.exit,
                exitActive: styles.exitActive,
            }, mountOnEnter: true, unmountOnExit: true, appear: true, timeout: { enter: 300, exit: 300 } },
            React.createElement("div", { className: styles.base, key: "networkErrorMsg" },
                React.createElement("div", { className: styles.wrapper },
                    React.createElement("p", null, showOfflineMessage ? translate('/Errors/Offline') : translate('/Errors/PageLoad')),
                    !showOfflineMessage && ( // No reason to show a try again message when we know that the user is offline
                    React.createElement("div", { className: styles.buttons },
                        React.createElement(Button, { className: styles.button, onClick: this.onRetry }, translate('/Errors/Retry'))))))));
    }
}
function oneHourHasPassedFrom(date) {
    return (new Date().valueOf() - date.valueOf()) / 1000 > 3600;
}
function isOnline() {
    return navigator.onLine === false ? false : true;
}
